<template>
    <div class="sidebar-nav-group">
        <div v-if="label" class="sidebar-nav-group__label">{{ label }}</div>
        <div class="sidebar-nav-group__items">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    label?: string;
}>();
</script>

<style lang="scss" scoped>
.sidebar-nav-group {
    @apply px-4 py-2 flex flex-col;

    &__label {
        @apply px-3 pt-2 pb-1 text-xs font-semibold tracking-[0.04em] uppercase text-zinc-400;
    }

    &__items {
        @apply flex flex-col gap-1;
    }
}
</style>
